import Vue from "vue";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
//import /* webpackPreload: true */ 'element-ui/lib/theme-chalk/fonts/element-icons.woff';

Vue.use(Element);
